import { Link } from "react-router-dom";

const features = [
  { icon: "ri-time-line", label: "Servicio profesional" },
  { icon: "ri-truck-line", label: "Flota moderna" },
  { icon: "ri-shield-check-line", label: "Totalmente asegurados" },
  { icon: "ri-map-pin-2-line", label: "Cobertura provincial" },
  { icon: "ri-award-line", label: "+15 años experiencia" },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_30549fffd9874dfe9a3e592c185102bb_819277df.jpg"
          alt="GERPAT Logística - Grúas y transporte en Lleida y Huesca"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-32 pb-20">
        <div className="max-w-3xl">
          <span className="inline-block bg-[#FF6B35] text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">
            Lleida · Huesca · España
          </span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: "1px" }}>
            GRÚA, TRANSPORTE Y<br />
            <span className="text-[#FF6B35]">COMPRA-VENTA DE VEHÍCULOS</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-10 leading-relaxed max-w-xl">
            Servicios profesionales de grúa y transporte en Lleida y Huesca. Asistencia en carretera y compra-venta de vehículos industriales y comerciales.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+34638250936"
              className="flex items-center justify-center gap-3 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-8 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-phone-fill text-lg"></i>
              SOLICITAR GRÚA AHORA
            </a>
            <Link
              to="/vehiculos"
              className="flex items-center justify-center gap-3 border-2 border-white text-white hover:border-[#FF6B35] hover:text-[#FF6B35] font-bold px-8 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-base"
            >
              VER VEHÍCULOS EN VENTA
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>

        {/* Feature pills */}
        <div className="mt-16 flex flex-wrap gap-3">
          {features.map((f) => (
            <div
              key={f.label}
              className="flex items-center gap-2.5 bg-black/50 backdrop-blur-sm border border-white/20 text-white px-5 py-3 rounded-full text-sm font-medium"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${f.icon} text-[#FF6B35] text-base`}></i>
              </div>
              {f.label}
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-xs uppercase tracking-widest">Descubrir</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
